import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

const updateStandalone = () => {
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;
  document.documentElement.dataset.standalone = isStandalone ? "true" : "false";
};

updateStandalone();
const media = window.matchMedia("(display-mode: standalone)");
if (media.addEventListener) {
  media.addEventListener("change", updateStandalone);
} else if (media.addListener) {
  media.addListener(updateStandalone);
}
window.addEventListener("appinstalled", updateStandalone);

createApp(App).use(router).mount("#app");
